import { eula_fr } from './eula_fr';

export const locale_fr = {
  ...eula_fr,
  Organization: 'Organisation',
  AreYouSureRemoveMemberFromGroupParam: 'Êtes-vous sûr de vouloir supprimer {0} membre du groupe ?',
  AreYouSureRemoveMembersFromGroupParam: 'Êtes-vous sûr de vouloir supprimer {0} membres du groupe ?',
  RowsSelected: 'ligne(s) sélectionnée(s)',
  AddToMembers: 'Ajouter aux membres',
  AssignRolesToGroup: 'Attribuer des rôles au groupe',
  Confirm: 'Confirmer',
  Name: 'Nom',
  Reset: 'Réinitialiser',
  SaveChanges: 'Enregistrer les modifications',
  GeneralProperties: 'Propriétés générales',
  AddMembersToGroup: 'Ajouter des membres au groupe',
  AddMembers: 'Ajouter des membres',
  UnexpectedError: 'Erreur inattendue',
  Confirmation: 'Confirmation',
  DeleteMember: 'Supprimer le membre',
  DeleteMembers: 'Supprimer les membres',
  Cancel: 'Annuler',
  User: 'Utilisateur',
  Search: 'Chercher',
  RemoveMember: 'Supprimer le membre',
  RemoveMembers: 'Supprimer des membres',
  PleaseSelect: 'Veuillez sélectionner',
  Role: 'Rôle',
  Scope: 'Portée',
  ScopeType: "Type d'étendue",
  RolesAssigned: 'Rôles attribués',
  SearchScope: 'étendue de la recherche',
  GroupParam: 'Groupe {0}',
  Home: 'Home',
  Groups: 'Groupes',
  Members: 'Membres',
  Roles: 'Rôles',
  AddGroup: 'Ajouter un groupe',
  GroupInfo: 'Informations sur le groupe',
  GroupMembers: 'Membres du groupe',
  CheckGroupInfoAndUsersTabs: 'Veuillez vérifier les informations sur le groupe et les onglets des membres. Quelque chose ne va pas',
  AddNewGroup: 'Ajouter un nouveau groupe',
  PleaseEnterName: 'Veuillez entrer un nom',
  OrganizationDatabaseHasBeenCreated: "La base de données de l'organisation a été créée",
  OK: 'OK',
  SomethingWentWrong: "Quelque chose s'est mal passé",
  OrganizationHasBeenBlocked: "L'organisation a été bloquée",
  OrganizationHasBeenUnblocked: "L'organisation a été débloquée",
  Yes: 'Oui',
  No: 'Non',
  DisplayName: "Nom d'affichage",
  Email: 'E-mail',
  Address: 'Adresse',
  PleaseEnterAValidEmail: 'Veuillez saisir une adresse e-mail valide',
  PleaseEnterAnAddress: 'Veuillez entrer une adresse',
  DefaultLanguage: 'Langue par défaut',
  IsPartner: 'Est un partenaire',
  IsBlocked: 'est bloqué',
  PartnerOrganization: 'Organisation partenaire',
  Unblock: 'Débloquer',
  Block: 'Bloquer',
  EnsureDB: 'Assurer la base de données',
  PleaseCheckTheInfoProvided: 'Veuillez vérifier les informations fournies. Quelque chose ne va pas',
  AddMembersToOrganization: "Ajouter des membres à l'organisation",
  PleaseSelectOrRemoveRow: 'Veuillez sélectionner ou supprimer une ligne',
  Add: 'Ajouter',
  AreYouSureRemoveMemberParam: "Êtes-vous sûr de vouloir supprimer {0} membre de l'organisation?",
  AreYouSureRemoveMembersParam: "Voulez-vous vraiment supprimer {0} membres de l'organisation ? ",
  DeleteUsers: 'Supprimer les utilisateurs',
  InvitationSent: 'Invitation envoyée',
  InvitationNotSent: 'Invitation non envoyée',
  ResendInvitation: "Renvoyer l'invitation",
  OrganizationMembers: "Membres de l'organisation",
  Reload: 'Recharger',
  TypeOrganizationNameToConfirm: "Saisir le nom de l'organisation à confirmer",
  Type: 'Type',
  OrganizationParam: 'Organisation {0}',
  Delete: 'Supprimer',
  CanNotDeleteOrgs: 'Impossible de supprimer les organisations',
  CanNotdeleteOwnOrganization: 'Impossible de supprimer sa propre organisation',
  AddOrganization: 'Ajouter une organisation',
  CheckOrganizationInfoAndUserTabs: "Veuillez vérifier les informations sur l'organisation et les onglets des utilisateurs.Quelque chose ne va pas",
  AddNewOrganization: 'Ajouter une nouvelle organisation',
  CreatingOrganizationAndItsDatabase:
    "Création de l'organisation et de sa base de données.Cela pourrait prendre plusieurs minutes.S'il vous plaît, attendez",
  PleaseSelectALanguage: 'Veuillez sélectionner une langue',
  PleaseSelectOrInvite: 'Veuillez sélectionner ou inviter',
  SelectOrInviteOrganizationMaster: "Sélectionner ou inviter l'organisation principale",
  OrganizationUsers: "Utilisateurs de l'organisation",
  SelectRoles: 'Sélectionner des rôles',
  AddUser: 'Ajouter un utilisateur',
  PartnerRoles: 'Rôles partenaires',
  EditPartnerRole: 'Modifier le rôle du partenaire',
  PleaseSelectASelector: 'Veuillez sélectionner un sélecteur',
  RoleName: 'Nom du rôle',
  RolesPermissions: 'Autorisations des rôles',
  Allow: 'Autoriser',
  Deny: 'Refuser',
  Selector: 'Sélecteur',
  Edit: 'Modifier',
  CreateRole: 'Créer un rôle',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    "Ce rôle est attribué par défaut aux créateurs de certains types d'étendues.Es - tu sûr de vouloir le supprimer?",
  RoleDelete: 'Êtes-vous sûr de vouloir supprimer ce rôle ?',
  DefaultRoleDelete: 'Êtes-vous sûr de vouloir supprimer ce rôle par défaut ?',
  NewPartnerRole: 'Nouveau rôle de partenaire',
  NewRole: 'Nouveau rôle',
  EditRole: 'Modifier le rôle',
  PleaseSelectAnOrganization: 'Veuillez sélectionner une organisation',
  AddToGroups: 'Ajouter aux groupes',
  AreYouSureWantRemoveUserFromGroup: "Êtes-vous sûr de vouloir supprimer l'utilisateur du groupe { 0} ?",
  AreYouSureWantRemoveUserFromGroups: "Êtes-vous sûr de vouloir supprimer l'utilisateur des groupes { 0 } ?",
  DeleteGroup: 'Supprimer le groupe',
  DeleteGroups: 'Supprimer des groupes',
  RemoveMembership: "Supprimer l'adhésion",
  RemoveMemberships: 'Supprimer les membres',
  AssignRolesToUser: "Attribuer des rôles à l'utilisateur",
  UserParam: 'Utilisateur {0}',
  CanNotDeleteOwnUser: 'Impossible de supprimer son propre utilisateur',
  PasswordMustMatch: 'Le mot de passe doit correspondre',
  AddNewUser: 'Ajouter un nouvel utilisateur',
  SetPassword: 'Définir le mot de passe',
  ConfirmPassword: 'Confirmer le mot de passe',
  BlankPasswordWarning:
    "Si vous laissez le champ du mot de passe vide, le système supposera que cet utilisateur utilisera un fournisseur d'authentification externe pour se connecter.",
  OrganizationsManagement: 'Gestion des Organisations',
  UsersManagement: 'Gestion des utilisateurs',
  RolesManagement: 'Gestion des rôles',
  PartnerRolesManagement: 'Gestion des rôles partenaires',
  GroupsManagement: 'Gestion des groupes',
  BackHome: 'Retour à la maison',
  HomeError: "Désolé, la page que vous avez visitée n'existe pas.",
  NotFound: 'Introuvable',
  ChangeOrganization: "Changer d'organisation",
  DeleteUser: "Supprimer l'utilisateur",
  ConfirmDeleteUser: "Êtes-vous sûr de vouloir supprimer l'utilisateur '{0}' avec l'adresse e-mail '{1}'?",
  UserDeleted: "L'utilisateur '{0}' avec l'adresse e-mail '{1}' a été supprimé avec succès.",

  DisplayingFilteredItems: 'Affichage des éléments filtrés par une notification.',
  ShowAllItems: 'Afficher tous les éléments',
  NotificationTimestampMessageMinutes: 'il y a {0} minutes',
  NotificationTimestampMessageHours: 'il y a {0} heures',
  Yesterday: 'Hier',
  Read: 'Lu',
  Unread: 'Non lu',
  Action: 'Action',
  AffectedElement: 'Élément affecté',
  LinkTo: 'Lien vers',
  State: 'État',
  Date: 'Date',
  Notifications: 'Notifications',
  NotificationStatus: 'Statut de la notification',
  InApp: 'Dans l’application',
  NotificationsSettings: 'Paramètres des notifications',
  DeleteAfter: 'Supprimer après',
  OneWeek: 'Une semaine',
  OneMonth: 'Un mois',
  OneYear: 'Un an',
  ThreeMonths: 'Trois mois',
  SixMonths: 'Six mois',
  DeleteAllNotifications: 'Supprimer tout',
  SurveySynchedRingNotificationDescription: 'Le survey "{A}" a été synchronisé sur le trou de forage "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'Le survey "{A}" a été synchronisé sur le Ring "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'Le survey "{A}" a été synchronisé dans la quarantaine.',
  OrganizationCreationFinishedNotificationTitle: 'Organisation créée',
  OrganizationExpirationWarningNotificationTitle: 'L’organisation est sur le point d’expirer',
  OrganizationCreationErrorNotificationTitle: 'Erreur lors de la création de l’organisation',
  OrganizationIsAvailableNotificationTitle: 'Organisation disponible',
  LicenseNeedsApprovalNotificationTitle: 'La licence nécessite une approbation',
  LicenseWasRenewedNotificationTitle: 'La licence a été renouvelée',
  RingCreatedNotificationTitle: 'Ring créé',
  SurveySynchedNotificationTitle: 'Survey synchronisé',
  ProjectDeletedNotificationTitle: 'Projet supprimé',
  ProjectEditedNotificationTitle: 'Projet modifié',
  DrillholeDeletedNotificationTitle: 'Trou de forage supprimé',
  RingDeletedNotificationTitle: 'Ring supprimé',
  DrillholeMovedNotificationTitle: 'Trou de forage déplacé',
  RingMovedNotificationTitle: 'Ring déplacé',
  DrillholeEditedNotificationTitle: 'Trou de forage mis à jour',
  RingEditedNotificationTitle: 'Ring mis à jour',
  SurveySignoffNotificationTitle: 'Demande d’approbation du survey',
  DrillholeCreatedNotificationTitle: 'Trou de forage créé',
  BulkDrillholesUpdateNotificationTitle: 'Trous de forage modifiés',
  BulkDrillholesMovedNotificationTitle: 'Trous de forage déplacés',
  BulkRingsMovedNotificationTitle: 'Rings déplacés',
  BulkDrillholesDeletedNotificationTitle: 'Trous de forage supprimés',
  BulkRingsDeletedNotificationTitle: 'Rings supprimés',
  BulkProjectsDeletedNotificationTitle: 'Projets supprimés',
  BulkRingsCreatedNotificationTitle: 'Rings créés',
  BulkDrillholesCreatedNotificationTitle: 'Trous de forage créés',
  SurveyDeletedNotificationTitle: 'Survey supprimé',
  SurveyDeletedNotificationDescription: 'Le survey "{A}" a été supprimé.',

  OrganizationCreationFinishedNotificationDescription: 'L’organisation {A} a été créée avec {X} membres.',
  OrganizationExpirationWarningNotificationDescription: 'L’organisation {A} est sur le point d’expirer.',
  OrganizationCreationErrorNotificationDescription: 'Une erreur est survenue lors de la création de l’organisation {A}.',
  OrganizationIsAvailableNotificationDescription: 'L’organisation {A} est maintenant disponible.',
  LicenseNeedsApprovalNotificationDescription: 'Une licence avec le code outil {A} nécessite une approbation.',
  LicenseWasRenewedNotificationDescription: 'Une licence avec le code outil {A} a été renouvelée.',
  SurveySynchedNotificationDescription: 'Le survey "{A}" a été synchronisé sur le trou de forage "{B}".',
  ProjectDeletedNotificationDescription: 'Le projet "{A}" a été supprimé.',
  ProjectEditedNotificationDescription: 'Le projet "{A}" a été modifié.',
  DrillholeDeletedNotificationDescription: 'Le trou de forage "{A}" a été supprimé.',
  RingDeletedNotificationDescription: 'Le Ring "{A}" a été supprimé.',
  DrillholeMovedNotificationDescription: 'Le trou de forage "{B}" a été déplacé vers "{A}".',
  RingMovedNotificationDescription: 'Le Ring "{B}" a été déplacé vers le projet "{A}".',
  DrillholeEditedNotificationDescription: 'Le trou de forage "{A}" a été mis à jour',
  RingEditedNotificationDescription: 'Le Ring "{A}" a été mis à jour',
  SurveySignoffNotificationDescription: 'Une approbation a été demandée pour le survey "{A}".',
  DrillholeCreatedNotificationDescription: 'Un trou de forage nommé "{B}" a été créé sur "{A}".',
  RingCreatedNotificationDescription: 'Un Ring nommé "{B}" a été créé dans le projet "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} trous de forage ont été modifiés sur "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} trous de forage ont été déplacés vers "{B}".',
  BulkRingsMovedNotificationDescription: '{X} Rings ont été déplacés vers le projet "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} trous de forage ont été supprimés',
  BulkRingsDeletedNotificationDescription: '{X} Rings ont été supprimés',
  BulkProjectsDeletedNotificationDescription: '{X} projets ont été supprimés.',
  BulkRingsCreatedNotificationDescription: '{X} Rings ont été créés.',
  BulkDrillholesCreatedNotificationDescription: '{X} trous de forage ont été créés sur "{B}".',
  ForgotPasswordNotificationTitle: 'E-mail de réinitialisation du mot de passe envoyé',
  OrganizationInvitationNotificationTitle: 'Invitation à une organisation reçue',
  LicenseQRSharedNotificationTitle: 'Licence partagée avec vous',
  ToolUsageReportNotificationTitle: 'Rapport d’utilisation des outils prêt',
  OrganizationCreationFinishedNotificationTitleError: 'Erreur lors de la création de l’organisation',
  OrganizationIsAvailableNotificationTitleError: 'Erreur lors de la mise à disposition de l’organisation',
  LicenseWasRenewedNotificationTitleError: 'Erreur lors du renouvellement de la licence',
  RingCreatedNotificationTitleError: 'Erreur lors de la création du Ring',
  SurveySynchedNotificationTitleError: 'Erreur lors de la synchronisation du survey',
  ProjectDeletedNotificationTitleError: 'Erreur lors de la suppression du projet',
  ProjectEditedNotificationTitleError: 'Erreur lors de la modification du projet',
  DrillholeDeletedNotificationTitleError: 'Erreur lors de la suppression du trou de forage',
  RingDeletedNotificationTitleError: 'Erreur lors de la suppression du Ring',
  DrillholeMovedNotificationTitleError: 'Erreur lors du déplacement du trou de forage',
  RingMovedNotificationTitleError: 'Erreur lors du déplacement du Ring',
  DrillholeEditedNotificationTitleError: 'Erreur lors de la mise à jour du trou de forage',
  RingEditedNotificationTitleError: 'Erreur lors de la mise à jour du Ring',
  DrillholeCreatedNotificationTitleError: 'Erreur lors de la création du trou de forage',
  BulkDrillholesUpdateNotificationTitleError: 'Erreur lors de la modification des trous de forage',
  BulkDrillholesMovedNotificationTitleError: 'Erreur lors du déplacement des trous de forage',
  BulkRingsMovedNotificationTitleError: 'Erreur lors du déplacement des Rings',
  BulkDrillholesDeletedNotificationTitleError: 'Erreur lors de la suppression des trous de forage',
  BulkRingsDeletedNotificationTitleError: 'Erreur lors de la suppression des Rings',
  BulkProjectsDeletedNotificationTitleError: 'Erreur lors de la suppression des projets',
  BulkRingsCreatedNotificationTitleError: 'Erreur lors de la création des Rings',
  BulkDrillholesCreatedNotificationTitleError: 'Erreur lors de la création des trous de forage',
  SurveyDeletedNotificationTitleError: 'Erreur lors de la suppression du survey',
  ForgotPasswordNotificationTitleError: 'Erreur lors de l’envoi de l’e-mail de réinitialisation du mot de passe',
  OrganizationInvitationNotificationTitleError: 'Erreur lors de l’envoi de l’invitation à l’organisation',
  LicenseQRSharedNotificationTitleError: 'Erreur lors du partage de la licence',
  ToolUsageReportNotificationTitleError: 'Erreur lors de la génération du rapport d’utilisation de l’outil',

  SurveyDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du survey "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Une erreur s’est produite lors de la création de l’organisation {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Une erreur s’est produite lors de la mise à disposition de l’organisation {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Une erreur s’est produite lors du renouvellement de la licence avec le code outil {A}.',
  SurveySynchedNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" sur le trou de forage "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du projet "{A}".',
  ProjectEditedNotificationDescriptionError: 'Une erreur s’est produite lors de la modification du projet "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du trou de forage "{A}".',
  RingDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du Ring "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement du trou de forage "{B}" vers "{A}".',
  RingMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement du Ring "{B}" vers le projet "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Une erreur s’est produite lors de la mise à jour du trou de forage "{A}".',
  RingEditedNotificationDescriptionError: 'Une erreur s’est produite lors de la mise à jour du Ring "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création du trou de forage "{A}" dans "{B}".',
  RingCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création du Ring "{A}" dans le projet "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Une erreur s’est produite lors de la modification de {X} trous de forage dans "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement de {X} trous de forage vers "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement de {X} Rings vers le projet "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression de {X} trous de forage.',
  BulkRingsDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression de {X} Rings.',
  BulkProjectsDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression de {X} projets.',
  BulkRingsCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création de {X} Rings.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création de {X} trous de forage dans "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Une erreur s’est produite lors de l’envoi de l’e-mail de réinitialisation du mot de passe.',
  OrganizationInvitationNotificationDescriptionError: 'Une erreur s’est produite avec une invitation à l’organisation. Veuillez vérifier.',
  LicenseQRSharedNotificationDescriptionError: 'Une erreur s’est produite lors du partage de la licence.',
  ToolUsageReportNotificationDescriptionError: 'Une erreur s’est produite lors de la génération ou de l’envoi du rapport d’utilisation de l’outil.',
  SurveySynchedRingNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" sur le trou de forage "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" sur le Ring "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" dans la quarantaine.',
  IsRead: 'Lu',
  RelatedEntityName: 'Nom de l’entité liée',
  RelatedEntityType: 'Type d’entité liée',
  RedirectEntityName: 'Nom de l’entité de redirection',
  RedirectEntityType: 'Type d’entité de redirection',
  Count: 'Nombre',
  Enable: 'Activer',
  SendNotificationsViaEmail: 'Envoyer les notifications par e-mail',
  Title: 'Titre',
  Description: 'Description',
  TypeHeader: 'Type',

  ForgotPasswordNotificationDescription: 'Un e-mail contenant un lien de réinitialisation du mot de passe a été envoyé.',
  OrganizationInvitationNotificationDescription:
    'Vous avez été invité à rejoindre une organisation. Veuillez consulter votre e-mail pour plus de détails.',
  LicenseQRSharedNotificationDescription: 'Une licence a été partagée avec vous. Veuillez consulter votre e-mail pour plus de détails.',
  ToolUsageReportNotificationDescription: 'Le rapport d’utilisation des outils a été généré avec succès et envoyé à votre e-mail.',

  Now: 'Maintenant',
  EmptyNotificationsTextTitle: 'Vous êtes à jour !',
  EmptyNotificationsTextSubtitle: 'Vous n’avez pas de nouvelles notifications',
  LastWeek: 'La semaine dernière',
  Today: "Aujourd'hui",
  ThisWeek: 'Cette semaine',
  ThisMonth: 'Ce mois-ci',
  MarkAsRead: 'Marquer comme lu',
  MarkAsReadAll: 'Marquer comme lues',

  //Permissions
  //Admin
  CreatePartnerOrganization: 'Créer une organisation partenaire',
  DeletePartnerOrganization: "Supprimer l'organisation partenaire",
  ManageDefaultRoles: 'Gérer les rôles par défaut',
  ManagePermissions: 'Gérer les autorisations',
  //Partners
  BlockOrganization: 'Bloc Organisation',
  CreateOrganization: 'Créer une organisation',
  DeleteOrganization: "Supprimer l'organisation",
  ManageLicenses: 'Gérer les licences',
  ManageRoleAssignment: 'Gérer les attributions de rôle',
  //Organization
  CreateProject: 'Créer un projet',
  ManageGroups: 'Gérer les groupes',
  ManageOrganizationInfo: "Gérer les informations sur l'organisation",
  ManageOrganizationRoleAssignments: "Gérer les attributions de rôles d'organisation",
  ManageQuarantine: 'Gérer la quarantaine',
  ManageRecycleBin: 'Gérer la corbeille',
  ManageRoles: 'Gérer les rôles',
  ManageUnitSystem: "Gérer le système d'unités",
  ManageUnitSystems: "Gérer les systèmes d'unités",
  ManageUsers: 'Gérer les utilisateurs',
  //Project
  CreateDrillhole: 'Créer un trou de forage',
  DeleteProject: 'Supprimer le projet',
  ManageProjectInfo: 'Gérer les informations sur le projet',
  ManageProjectRoleAssignments: 'Gérer les attributions de rôles de projet',
  ViewProjectData: 'Afficher les données du projet',
  //Ring
  CreateRing: 'Créer un ring',
  DeleteRing: 'Supprimer le ring',
  ManageRingInfo: 'Gérer les informations sur le ring',
  ManageRingRoleAssignments: 'Gérer les attributions de rôles en ring',
  ShareRing: 'Partager le ring',
  ViewRingData: 'Afficher les données de le ring',
  CreateRingDrillhole: 'Créer des trous de forage pour le ring',
  //Drillhole
  DeleteDrillhole: 'Supprimer le trou de forage',
  ManageDrillholeInfo: 'Gérer les informations sur les trous de forage',
  ManageDrillholeRoleAssignments: 'Gérer les attributions de rôles de forage',
  ViewDrillholeData: 'Afficher les données de forage',
  ManageSurveys: 'Gérer les sondages',
  SynchronizeSurveys: 'Synchroniser les sondages',
  WelcomeBackParam: 'Bienvenue, {0} !',
  Change: 'Modifier',
  Unauthorized: 'Non autorisé',
  YouDontHaveAccessToSite: "Vous n'avez pas accès à l'espace partenaires",
  LoginOutInSecondsParam: 'Déconnexion dans {0} secondes',
  AssignRoleWarning:
    "Vous attribuez des rôles : {0} à {1} au niveau de l'organisation. Les rôles seront appliqués à toutes les entités sélectionnées et {1} aura la permission de toutes les informations contenues dans {2}",
  UpdateExpiredRoleWarning:
    'Les rôles : {0} ont été précédemment attribués à {1}, mais ont expiré. La date sélectionnée remplacera la date d’expiration précédente et les rôles redeviendront actifs.',
  DoYouWantToContinue: 'Voulez-vous continuer?',
  MemberAlreadyInOrganizarion: "L'utilisateur est déjà membre de l'organisation {0}",
  YouHaveSelectedThisUserMoreThanOnce: "Vous avez sélectionné cet utilisateur plus d'une fois",
  ClearFilter: 'Effacer le filtre',
  ElementsSussessfulyDeleted: 'Éléments supprimés avec succès',
  DownloadErrorsFile: "Télécharger le fichier d'erreurs",
  Errors: 'Erreurs',
  DownloadWarningsFile: "Télécharger le fichier d'avertissements",
  Warnings: 'Avertissements',
  FailDeletion: 'Échec de la suppression',
  OrderBy: 'Trier par',
  rowsSelected: 'ligne(s) sélectionnée(s)',
  AddNew: 'Ajouter nouveau',
  DeleteAll: 'Supprimer tout',
  ImportCSV: 'Importer CSV',
  BulkUploadItems: 'Télécharger des éléments en masse',
  Licenses: 'Licenses',
  ToolCode: "Code d'outil",
  DeviceType: "Type d'appareil",
  FromDate: 'Depuis la date',
  UntilDate: "Jusqu'à la date",
  CreatedOn: 'Créé sur',
  CreatedBy: 'Créé par',
  Unlimited: 'Illimité',
  Coefficients: 'Coefficients',
  Continuous: 'Continu',
  Multishot: 'Prise multiple',
  Zupt: 'Zupt',
  Offline: 'Hors ligne',
  Flash: 'Flash',
  Notes: 'Remarques',
  AddLicense: 'Ajouter licence',
  AddNewLicense: 'Ajouter une nouvelle licence',
  PleaseEnterToolCode: "Veuillez entrer le code de l'outil",
  LicenseCopied: 'Licence copiée dans le presse-papiers',
  License: 'Licence',
  Copy: 'Copier',
  ErrorLoadingLicense: 'Erreur lors du chargement de la licence',
  ShowLicense: 'Afficher la licence',
  LicenseAlreadyExists:
    'Vous essayez de créer une nouvelle licence pour {0} #{1} du {6} au {7}, mais une licence existe déjà pour {0} #{1} du {2} au {3}, créée par {4} le {5}. Voulez-vous continuer et créer une nouvelle licence quand même ?',
  UnlimitedLicenseAlreadyExists:
    'Une licence illimitée a déjà été créée pour {0} #{1} par {2} le {3}. Voulez-vous continuer et créer une nouvelle licence quand même ?',
  Continue: 'Continuer',
  PeriodOfValidity: 'Période De Validité',
  CopyLicense: 'Copier la licence',
  CopyAll: 'Copier tout',
  PleaseSelectDates: 'Veuillez sélectionner des dates',
  Project: 'Projet',
  Customer: 'Client',
  ExportCSV: 'Exporter CSV',
  Reports: 'Rapports',
  Export: 'Exporter',
  Separator: 'Séparateur',
  Tab: 'Onglet',
  Semicolon: 'Point-virgule',
  Comma: 'Virgule',
  AreYouSureYouWantToDelete: 'Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?',
  AreYouSureYouWantToDeleteSelected: 'Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?',
  ThereWasAProblemCreatingLicense: 'Il y a eu un problème lors de la création de la licence.Veuillez contacter un administrateur.',
  ExpirationDate: "Date d'expiration",
  UpdateRoleAttributes: 'Modifier les attributs de rôle',
  Update: 'Modifier',
  AllowedDevices: 'Appareils autorisés',
  RoleExpirationDate: "Date d'expiration du rôle",
  PleaseEnterExpirationDate: "Veuillez entrer une date d'expiration",
  MaximumLicenseDueDate: "Date d'échéance maximale de la licence",
  PleaseEnterMaxDueDate: "Veuillez saisir la date d'échéance maximale de la licence",
  MaxLicensesPeriodInDays: 'Durée maximale de la licence en jours',
  PleaseEnterMaxLicensesPeriodInDays: 'Veuillez saisir la durée maximale de la licence en jours',
  MaxNumberOfLicensesPerMonth: 'Nombre maximal de licences par mois',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Veuillez entrer le nombre maximum de licences par mois',
  DeleteElements: 'Supprimer des éléments',
  DeleteItems: 'Supprimer des éléments',
  DeleteSelected: 'Supprimer la sélection',
  DeviceTypeNotAllowed: "Vous n'êtes pas autorisé à créer une licence pour cet appareil",
  MaximumLicenseDueDateReached: "Vous n'êtes pas autorisé à créer des licences dont la date d'échéance est postérieure au {0}",
  MaxLicensesPeriodInDaysReached: 'Les licences que vous créez doivent être valides pour une période de {0} jours au maximum.',
  MaxNumberOfLicensesPerMonthReached:
    'Vous avez atteint le nombre maximum de licences créées par mois. Veuillez attendre le mois prochain pour créer une nouvelle licence.',
  ApprovalPending: 'Approbation en attente',
  InitializingOrganization: "L'organisation s'initialise. Les utilisateurs seront bientôt disponibles",
  InvalidToolCode: "Le code de l'outil doit comporter exactement quatre chiffres.",
  EditRoles: 'Modifier les rôles',
  EditRolesMessage: "Modifier les rôles d'utilisateur",
  RolesWillBeRemoved: 'Les rôles suivants seront supprimés : {0}. ',
  RolesWillBeAssigned: 'Les rôles suivants seront attribués : {0}. ',
  ThisUserIsOrganizationMaster: "Cet utilisateur a déjà été sélectionné comme maître de l'organisation",
  RemainingLicensesMessage: 'Il vous reste un total de {0} licences restantes pour ce mois',
  MaxLicenseNumberReached: 'Vous avez atteint le nombre maximum de licences pour ce mois-ci',
  EULATitle: "Contrat de licence d'utilisateur final (EULA)",
  OrganizationIsExporting: "L'organisation est en cours d'exportation, veuillez patienter...",
  ErrorExportingOrganization: "Une erreur s'est produite lors de l'exportation de l'organisation {0}. Veuillez réessayer",
  ExportingOrganizationSuccess:
    "Le processus d'exportation a commencé. Une fois terminé, nous vous enverrons le lien de téléchargement par courrier électronique.",
  CanNotDeleteOrganizationWhileExporting:
    "L'organisation {0} est en cours d'exportation et ne peut pas être supprimée pour le moment. Veuillez patienter et réessayer dans un moment.",
  CheckingIfOrganizationExists: "Vérifier si l'organisation existe...",
  RestoreOrganizationConfirmDialog:
    'Cette organisation existe déjà, voulez-vous continuer ? Toutes les données de cette organisation seront écrasées par les données de sauvegarde.',
  ExportingProcessStarted: "Le processus d'exportation a démarré, le téléchargement va commencer sous peu",
  ExportOrganization: "Exporter l'organisation",
  ImportOrganization: "Importer l'organisation",
  UploadOrganizationBackup: "Télécharger la sauvegarde de l'organisation",
  AddOrganizationFile: "Cliquez ou faites glisser le fichier de sauvegarde de l'organisation dans cette zone pour le télécharger",
  ImportingOrganizationStarted: "Le processus d'importation a commencé",
  ImportingOrganizationSuccess:
    "Le processus d'importation a commencé, une fois terminé, nous vous enverrons une notification à votre adresse électronique",
  ErrorImportingOrganization: "Une erreur s'est produite lors de l'importation de l'organisation. Veuillez réessayer",
  Importing: 'Importation...',
  LastImportDate: "Cette organisation a été restaurée pour la dernière fois à partir d'une sauvegarde le ",
  ShowOrganizationLicenses: "Licences d'organisation",
  ShowAll: 'Afficher tout',

  DefaultRolesTableError: "Une erreur s'est produite lors du chargement des rôles par défaut. Veuillez réessayer",
  GroupsTableError: "Une erreur s'est produite lors du chargement des groupes. Veuillez réessayer",
  ErrorSavingGroupProperties: "Une erreur s'est produite lors de l'enregistrement des propriétés du groupe. Veuillez réessayer",
  ErrorAddingGroupMembers: "Une erreur s'est produite lors de l'ajout de membres au groupe. Veuillez réessayer",
  GroupRolesTableError: "Une erreur s'est produite lors du chargement des rôles du groupe. Veuillez réessayer",
  LicensesTableError: "Une erreur s'est produite lors du chargement des licences. Veuillez réessayer",
  OrganizationsTableError: "Une erreur s'est produite lors du chargement des organisations. Veuillez réessayer",
  ErrorAddingOrganizationMembers: "Une erreur s'est produite lors de l'ajout de nouveaux membres à l'organisation. Veuillez réessayer.",
  ErrorRemovingOrganizationMembers: "Une erreur s'est produite lors de la suppression des nouveaux membres de l'organisation. Veuillez réessayer",
  RoleListTableError: "Une erreur s'est produite lors du chargement des rôles. Veuillez réessayer",
  UsersTableError: "Une erreur s'est produite lors du chargement de la liste des utilisateurs. Veuillez réessayer",
  ErrorAddingGroup: "Une erreur s'est produite lors de l'ajout du groupe. Veuillez réessayer",
  ErrorRemovingGroup: "Une erreur s'est produite lors de la suppression du groupe. Veuillez réessayer",
  UserRolesTableError: "Une erreur s'est produite lors du chargement des rôles des utilisateurs. Veuillez réessayer",
  InvitationNotSentErrorMessage: "Une erreur s'est produite lors de l'envoi de l'invitation. Veuillez réessayer",
  ErrorDeletingUser: "Une erreur s'est produite lors de la suppression de l'utilisateur. Veuillez réessayer.",
  PartnerRolesTableError: "Une erreur s'est produite lors du chargement des rôles des partenaires. Veuillez réessayer.",
  PaginationTotal: 'Afficher {0} éléments de {1}',
  SelectOrInviteUser: 'Sélectionner ou inviter un utilisateur',
  SelectOrInviteUsers: 'Sélectionner ou inviter des utilisateurs',
  CheckDB: 'Vérifier la base de données',
  ManageGlobalLicenses: 'Gérer les licences globales',
  ManageRoleAssignments: 'Gérer les attributions de rôles',
  ShareDrillhole: 'Partager des trous de forage',
  SignOffSurveys: 'Signer des enquêtes',
  ViewSurveyData: "Afficher les données d'enquête",
  Organizations: 'Organisations',
  SelectSelector: 'Sélectionner le sélecteur',
  SelectOrganization: "Sélectionner l'organisation",
  GroupMembership: 'Appartenance au groupe',
  SelectEntity: 'Sélectionner une entité',
  Users: 'Utilisateurs',
  AddUserToGroups: 'Ajouter un utilisateur aux groupes',
  SelectLanguage: 'Sélectionner la langue',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  Restore: 'Restaurer',
  RestoreBackupConfirmMessage:
    "Voulez-vous restaurer cette sauvegarde ? Toute modification apportée à l'organisation après la création de la sauvegarde sera perdue.",
  RestoreBackupSuccess: 'Le processus de restauration de sauvegarde a démarré. Une fois terminé, nous vous enverrons un e-mail.',
  Backups: 'Sauvegardes',
  OrganisationBackups: 'Sauvegardes organisationnelles',
  OrganizationName: "Nom de l'organisation",
  Statistics: 'Statistiques',
  Last24Hours: 'Dernières 24 heures',
  Last3Days: 'Les 3 derniers jours',
  Last7Days: 'Les 7 derniers jours',
  Last28Days: 'Les 28 derniers jours',
  FilterByDate: 'Filtre par date',
  Projects: 'Projets',
  Surveys: 'Enquêtes',
  ProjectsNumber: 'Nombre de projets',
  UsersNumber: "Nombre d'utilisateurs",
  SurveysNumber: "Nombre d'enquêtes",
  CreationDate: 'Date de création',
  LastUpdate: 'Dernière mise à jour',
  CustomDateRange: 'Plage de dates personnalisée',
  OrganizationIsLocked:
    'Cette organisation est actuellement verrouillée car elle est utilisée dans un autre processus. Veuillez patienter et réessayer dans quelques instants.',
  SelectGroups: 'Sélectionner des groupes',
  ErrorUpdatingRole: "Une erreur s'est produite lors de la mise à jour des autorisations du rôle. Veuillez réessayer.",

  WorkingHours: 'Heures de travail',
  PleaseEnterWorkingHours: 'Veuillez entrer les heures de travail',

  Country: 'Pays',
  PleaseSelectCountry: 'Veuillez sélectionner un pays',

  Afghanistan: 'Afghanistan',
  Albania: 'Albanie',
  Algeria: 'Algérie',
  Andorra: 'Andorre',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antigua-et-Barbuda',
  Argentina: 'Argentine',
  Armenia: 'Arménie',
  Australia: 'Australie',
  Austria: 'Autriche',
  Azerbaijan: 'Azerbaïdjan',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahreïn',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbade',
  Belarus: 'Biélorussie',
  Belgium: 'Belgique',
  Belize: 'Belize',
  Benin: 'Bénin',
  Bhutan: 'Bhoutan',
  Bolivia: 'Bolivie',
  'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
  Botswana: 'Botswana',
  Brazil: 'Brésil',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgarie',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Cambodge',
  Cameroon: 'Cameroun',
  Canada: 'Canada',
  'Cape Verde': 'Cap-Vert',
  'Central African Republic': 'République centrafricaine',
  Chad: 'Tchad',
  Chile: 'Chili',
  China: 'Chine',
  Colombia: 'Colombie',
  Comoros: 'Comores',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Côte d’Ivoire',
  Croatia: 'Croatie',
  Cuba: 'Cuba',
  Cyprus: 'Chypre',
  'Czech Republic': 'République tchèque',
  'Democratic Republic of the Congo': 'République démocratique du Congo',
  Denmark: 'Danemark',
  Djibouti: 'Djibouti',
  Dominica: 'Dominique',
  'Dominican Republic': 'République dominicaine',
  'East Timor': 'Timor oriental',
  Ecuador: 'Équateur',
  Egypt: 'Égypte',
  'El Salvador': 'Salvador',
  'Equatorial Guinea': 'Guinée équatoriale',
  Eritrea: 'Érythrée',
  Estonia: 'Estonie',
  Ethiopia: 'Éthiopie',
  Fiji: 'Fidji',
  Finland: 'Finlande',
  France: 'France',
  Gabon: 'Gabon',
  Gambia: 'Gambie',
  Georgia: 'Géorgie',
  Germany: 'Allemagne',
  Ghana: 'Ghana',
  Greece: 'Grèce',
  Grenada: 'Grenade',
  Guatemala: 'Guatemala',
  Guinea: 'Guinée',
  'Guinea-Bissau': 'Guinée-Bissau',
  Guyana: 'Guyane',
  Haiti: 'Haïti',
  Honduras: 'Honduras',
  Hungary: 'Hongrie',
  Iceland: 'Islande',
  India: 'Inde',
  Indonesia: 'Indonésie',
  Iran: 'Iran',
  Iraq: 'Irak',
  Ireland: 'Irlande',
  Israel: 'Israël',
  Italy: 'Italie',
  Jamaica: 'Jamaïque',
  Japan: 'Japon',
  Jordan: 'Jordan',
  Kazakhstan: 'Kazakhstan',
  Kenya: 'Kenya',
  Kiribati: 'Kiribati',
  Kuwait: 'Koweït',
  Kyrgyzstan: 'Kirghizistan',
  Laos: 'Laos',
  Latvia: 'Lettonie',
  Lebanon: 'Liban',
  Lesotho: 'Lesotho',
  Liberia: 'Liberia',
  Libya: 'Libye',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituanie',
  Luxembourg: 'Luxembourg',
  Madagascar: 'Madagascar',
  Malawi: 'Malawi',
  Malaysia: 'Malaisie',
  Maldives: 'Maldives',
  Mali: 'Mali',
  Malta: 'Malte',
  'Marshall Islands': 'Îles Marshall',
  Mauritania: 'Mauritanie',
  Mauritius: 'Maurice',
  Mexico: 'Mexique',
  Micronesia: 'Micronésie',
  Moldova: 'Moldavie',
  Monaco: 'Monaco',
  Mongolia: 'Mongolie',
  Montenegro: 'Monténégro',
  Morocco: 'Maroc',
  Mozambique: 'Mozambique',
  Myanmar: 'Birmanie',
  Namibia: 'Namibie',
  Nauru: 'Nauru',
  Nepal: 'Népal',
  Netherlands: 'Pays-Bas',
  'New Zealand': 'Nouvelle-Zélande',
  Nicaragua: 'Nicaragua',
  Niger: 'Niger',
  Nigeria: 'Nigeria',
  'North Korea': 'Corée du Nord',
  Norway: 'Norvège',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palau: 'Palau',
  Panama: 'Panama',
  'Papua New Guinea': 'Papouasie-Nouvelle-Guinée',
  Paraguay: 'Paraguay',
  Peru: 'Pérou',
  Philippines: 'Philippines',
  Poland: 'Pologne',
  Portugal: 'Portugal',
  Qatar: 'Qatar',
  'Republic of the Congo': 'République du Congo',
  'Republic of Macedonia': 'Macédoine',
  Romania: 'Roumanie',
  Russia: 'Russie',
  Rwanda: 'Rwanda',
  'Saint Kitts and Nevis': 'Saint-Christophe-et-Niévès',
  'Saint Lucia': 'Sainte-Lucie',
  'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
  Samoa: 'Samoa',
  'San Marino': 'Saint-Marin',
  'Sao Tome and Principe': 'São Tomé-et-Principe',
  'Saudi Arabia': 'Arabie saoudite',
  Senegal: 'Sénégal',
  Serbia: 'Serbie',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Sierra Leone',
  Singapore: 'Singapour',
  Slovakia: 'Slovaquie',
  Slovenia: 'Slovénie',
  'Solomon Islands': 'Îles Salomon',
  Somalia: 'Somalie',
  'South Africa': 'Afrique du Sud',
  'South Korea': 'Corée du Sud',
  'South Sudan': 'Soudan du Sud',
  Spain: 'Espagne',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Soudan',
  Suriname: 'Suriname',
  Swaziland: 'Swaziland',
  Sweden: 'Suède',
  Switzerland: 'Suisse',
  Syria: 'Syrie',
  Tajikistan: 'Tadjikistan',
  Tanzania: 'Tanzanie',
  Thailand: 'Thaïlande',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinité-et-Tobago',
  Tunisia: 'Tunisie',
  Turkey: 'Turquie',
  Turkmenistan: 'Turkménistan',
  Tuvalu: 'Tuvalu',
  Uganda: 'Ouganda',
  Ukraine: 'Ukraine',
  'United Arab Emirates': 'Émirats arabes unis',
  'United Kingdom': 'Royaume-Uni',
  'United States of America': 'États-Unis',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Ouzbékistan',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Viêt Nam',
  Yemen: 'Yémen',
  Zambia: 'Zambie',
  Zimbabwe: 'Zimbabwe',

  TestOrganization: 'Organisation de test',
  RemovalDate: 'Date de suppression',
  IsTestOrganization: 'Est une organisation de test',
  TestingEndDate: 'Date de fin de test',
  TestOrgConfirmationMessage:
    "L'entité a été établie comme une organisation de test et sera automatiquement supprimée à la date sélectionnée. Êtes-vous sûr de vouloir continuer ?",

  Show: 'Afficher',
  Changed: 'Changé',
  Unchanged: 'Inchangé',

  Charts: 'Graphiques',

  CreationChartLegend: 'Création',
  UpdateChartLegend: 'Mise à jour',

  WelcomBackParam: 'Bienvenue, {0} !',
  LicenseDetails: 'Détails de la licence',
  Logout: 'Déconnexion',

  CrashError: "Oups ! Quelque chose s'est vraiment mal passé",
  SeeAllLogs: "Veuillez appuyer sur F12 et envoyer tous les journaux dans l'onglet Console lorsque vous signalez cet incident",
  ReturnHome: 'Retour à la maison',

  InvalidEmailWarning: 'Veuillez sélectionner ou saisir un e-mail valide',
  CheckOrganizationInfoAndUsersTabs: "Veuillez vérifier les informations sur l'organisation et les onglets des utilisateurs.Quelque chose ne va pas",

  UserHasNoOrganizationsWarning:
    "Cet utilisateur ne fait partie d'aucune organisation. Veuillez l'ajouter à une organisation avant de lui attribuer des rôles.",

  UserHasNoOrganizationsGroupWarning:
    "Cet utilisateur ne fait partie d'aucune organisation. Veuillez l'ajouter à une organisation avant de l'ajouter à des groupes.",

  'Customer Geologist': 'Géologue client',
  'Drillhole Manager': 'Gestionnaire de forages',
  'Field Operator': 'Opérateur de terrain',
  Geologist: 'Géologue',
  'Global License Manager': 'Gestionnaire de licences globales',
  'License Manager': 'Gestionnaire de licences',
  'Organization Coordinator': "Coordinateur de l'organisation",
  'Organization Master': "Maître de l'organisation",
  'Partner Administrator': 'Administrateur partenaire',
  'Project Manager': 'Gestionnaire de projet',
  'Project Viewer': 'Visualiseur de projets',
  'Ring Manager': 'Gestionnaire des rings',

  Partners: 'Partenaires',

  ActiveHours: 'Heures active',
  Active: 'Actif',
  NotActive: 'Non actif',
  Status: 'Statut',
  Go: 'Aller',
  FilterByActiveDates: 'Filtrer par dates active',
  ActiveDays: 'Jours active',

  CanCreateUnlimitedLicense: "Peut créer des licences qui n'expirent pas",
  CanCreateRecurrentLicenses: 'Peut créer des licences récurrentes',
  Recurrence: 'Récurrence',
  Activated: 'Activé',
  Deactivated: 'Désactivé',

  NeedsSignOff: 'Approbation requise',
  SelectedUserAlreadyHasTheSelectedRoles: "L'utilisateur sélectionné a déjà les rôles: {0}.",
  SelectedGroupAlreadyHasTheSelectedRoles: 'Le groupe sélectionné a déjà les rôles : {0}.',

  FilterMode: 'Mode de filtre',
  AllSelected: 'Tous sélectionnés',
  AnyOfTheSelected: 'N’importe lequel des sélectionnés',
  Download: 'Télécharger',

  RoleAssignmentAttributes: 'Attributs d’attribution de rôle',
  LicenseManagerRoleAttributes: 'Attributs du rôle de gestionnaire de licences',

  'StructMaster User': 'Utilisateur de StructMaster',
  UseStructMaster: 'Utiliser StructMaster',

  StructmasterLicenses: 'Licences StructMaster',
  NewStructmasterLicenseAssignment: 'Nouvelle affectation de licence StructMaster',
  EditStructmasterLicenseAssignment: 'Modifier l’affectation de licence StructMaster',
  SelectUser: 'Sélectionner un utilisateur',
  UserAlreadyHasStructMasterRole: 'Erreur : Cet utilisateur a déjà le rôle StructMaster pour cette organisation',
  AddAnotherAssignment: 'Ajouter une autre affectation',
  AddRole: 'Ajouter un rôle',
  SelectRole: 'Sélectionner un rôle',
  PleaseSelectRole: 'Veuillez sélectionner un rôle',
  DuplicatedRolesWarning: 'Il y a des rôles en double dans votre sélection. Assurez-vous qu’il n’y a pas de doublons.',
  RolesWillBeUpdated: 'Les rôles suivants seront mis à jour : {0}.',

  UserHasNoRoleWarning: "L'utilisateur doit avoir au moins un rôle dans l'organisation",

  UserWillBeAddedToOrganizationBeforeAssign:
    "Avertissement : L'utilisateur '{0}' n'appartient pas à l'organisation '{1}' , par conséquent, l'utilisateur '{0}' sera ajouté à l'organisation avant d'effectuer l'attribution.",

  ManageCategories: 'Gérer les catégories',
  ManageGeographicInformationSystems: 'Gérer les systèmes d’information géographique',

  Appearance: 'Apparence',
  DarkTheme: 'Thème sombre',
  LightTheme: 'Thème clair',
  UseSystemTheme: 'Utiliser le thème du système',
  ScheduledMaintenanceText:
    'Maintenance programmée : La plateforme cloud fera l’objet d’une maintenance programmée le {0}. Les services peuvent être interrompus pendant une durée estimée de {1} heures, à partir de {2}',
  MFAStatus: 'Statut de l’authentification multifacteur',
  Enabled: 'Activé',
  Disabled: 'Désactivé',
  EnableMFA: 'Activer l’authentification multifacteur',
  DisableMFA: 'Désactiver l’authentification multifacteur',

  UserLimit: 'Limite d’utilisateurs',
  PleaseEnterUserLimit: 'Veuillez entrer la limite d’utilisateurs',
  CheckLicenseInfoAndUsersTabs: 'Veuillez vérifier les onglets d’information de licence et d’utilisateurs. Quelque chose ne va pas',
  LicenseInfo: 'Informations sur la licence',
  AddNewStructmasterLicense: 'Ajouter une nouvelle licence StructMaster',
  StructmasterLicense: 'Licence StructMaster',
  PleaseAddAtLeastOneUser: 'Veuillez ajouter au moins un utilisateur',
  DuplicatedUserWarning: 'Cet utilisateur est déjà sélectionné, veuillez vérifier',
  LicenseName: 'Nom de la licence',
  UserAmountExceedLimit: 'Le nombre d’utilisateurs saisi dépasse la limite sélectionnée, veuillez vérifier que les données sont correctes.',

  UserAlreadyIsLicenseManagerError:
    'Cet utilisateur fait déjà partie d’un groupe de gestionnaires de licences. Veuillez sélectionner un autre utilisateur',
  UserAlreadyIsStructmasterUserError: 'Cet utilisateur a déjà le rôle de StructMaster. Veuillez sélectionner un autre utilisateur',
  DefaultGroups: 'Groupes par défaut',
  LicenseManagerGroups: 'Groupes de gestionnaires de licences',
  UpdateAttributes: 'Mettre à jour les attributs',
  ResetLicenseAccess: 'Réinitialiser l’accès à la licence',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Cet utilisateur fait déjà partie d’un groupe de gestionnaires de licences, et il y a au moins un groupe de gestionnaires de licences dans votre sélection. Veuillez vérifier cela',
  MoreThanOneLicenseManagerGroupSelectedError:
    'Il y a plus d’un groupe de gestionnaires de licences dans votre sélection, et un utilisateur ne peut appartenir qu’à un seul groupe de gestionnaires de licences. Veuillez vérifier votre sélection.',
  Default: 'Par défaut',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Il existe déjà une licence StructMaster avec ce nom, veuillez choisir un autre nom.',
  ThereIsAlreadyAGroupWithThisName: 'Il existe déjà un groupe avec ce nom, veuillez choisir un autre nom',

  GroupLogsTableError: 'Une erreur s’est produite lors du chargement des journaux d’audit du groupe. Veuillez réessayer.',
  DownloadQR: 'Télécharger le QR',
  FilterByUser: 'Filtrer par utilisateur',

  ActiveUser: 'Utilisateur actif',

  AllowAllPermissionsForThisLevel: 'Autoriser toutes les permissions pour ce niveau',
  AllowAllAvailablePermissions: 'Autoriser toutes les permissions disponibles',
  AllowAllAvaliablePermissionsForThisSelector: 'Autoriser toutes les permissions disponibles pour ce sélecteur',

  StructmasterLicensesOnlyOneActiveUserWarning:
    'Avertissement : Il ne peut y avoir qu’un seul utilisateur actif à la fois pour chaque licence StructMaster.',

  SelectUsersToShare: 'Sélectionner les utilisateurs à partager',
  SelectOrEnterEmailAddress: 'Sélectionner un utilisateur ou saisir une adresse e-mail',
  Share: 'Partager',
  NoUsersSelectedError: 'Veuillez sélectionner au moins un utilisateur ou saisir une adresse e-mail',
  AddEmail: 'Ajouter un e-mail',

  OrganizationUserLimitWarningCreation: 'Avertissement : Vous ne pouvez ajouter qu’un maximum de {0} utilisateurs à une organisation',
  OrganizationUserLimitWarningParam:
    'Avertissement : Vous ne pouvez ajouter qu’un maximum de {0} utilisateurs à cette organisation, et vous en avez déjà un total de {1}, donc vous ne pourrez en ajouter que {2}.',
  OrganizationReachedUserLimit:
    'Erreur : Cette organisation a déjà atteint le nombre maximal d’utilisateurs autorisés. Veuillez sélectionner une autre organisation.',
  NewGroupUserCountErrorParam:
    'Erreur : Cette organisation a un maximum de {0} utilisateurs, avec actuellement {1} utilisateurs, et vous essayez d’en ajouter {2} nouveaux. Veuillez vérifier que les informations sont correctes.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Les utilisateurs suivants seront ajoutés à l’organisation :',

  UnsignedStructmasterLicenses: 'Licences StructMaster non signées',
  SaveAndSignOff: 'Enregistrer et signer',
  SignOffStructmasterLicenseWarningTitle: 'Signer la licence StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Vous êtes sur le point d’approuver la création d’une nouvelle licence StructMaster. Les utilisateurs seront ajoutés à l’organisation sélectionnée s’ils n’en font pas déjà partie, et le rôle leur sera attribué. Voulez-vous continuer ?',

  ShowOnlyUnsignedLicenses: 'Afficher uniquement les licences en attente d’approbation',
  ClearFilters: 'Effacer les filtres',
  ApproveLicenses: 'Approuver les licences',
  Save: 'Enregistrer',

  SoftwareVersion: 'Version du logiciel',
  AnErrorOcurred: "Une erreur s'est produite :",
  DeleteUnsignedLicense: 'Supprimer la licence non approuvée',
  DeleteUnsignedLicenseWarning: 'Êtes-vous sûr de vouloir supprimer la licence non approuvée « {0} » ?',
  SignOff: 'Approuver',
  Refuse: 'Refuser',
  ErrorCreatingLicense: 'Erreur lors de la création de la licence',
  ErrorUpdatingLicense: 'Erreur lors de la mise à jour de la licence',

  DuplicatedRoleNameErrorCreate:
    'Erreur lors de la création du rôle : Un rôle nommé "{0}" existe déjà dans l’organisation "{1}". Veuillez entrer un nom différent.',
  DuplicatedRoleNameErrorUpdate:
    'Erreur lors de la mise à jour du rôle : Un rôle nommé "{0}" existe déjà dans l’organisation "{1}". Veuillez entrer un nom différent.',
  DuplicatedDefaultRoleNameErrorUpdate:
    'Erreur lors de la mise à jour du rôle : Un rôle par défaut nommé "{0}" existe déjà. Veuillez entrer un nom différent.',
  PleaseEnterAValidSearchTerm: 'Veuillez saisir un terme de recherche valide',
  TextFieldLimitError: 'Le champ "{0}" ne doit pas dépasser {1} caractères',
  InvalidToolcode: 'Veuillez saisir un code outil valide',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Les groupes de gestionnaire de licences doivent avoir au moins un rôle',
  PleaseSelectAtLeastOneDeviceType: 'Veuillez sélectionner au moins un type d’appareil',
  Language: 'Langue',
  NoData: 'Aucune donnée',
  PleaseEnterCoreDiameter: 'Veuillez saisir le diamètre du carottage',
  CoreDiameter: 'Diamètre du carottage',
  SmartCoreLicenseAlreadyExists:
    'Vous tentez de créer une nouvelle licence pour {0} #{1} avec un diamètre d’outil "{8}" du {6} au {7}, mais une licence existe déjà pour {0} #{1} avec un diamètre d’outil "{8}" du {2} au {3}, créée par {4} le {5}. Voulez-vous continuer et créer une nouvelle licence malgré tout ?',
  UnlimitedSmartCoreLicenseAlreadyExists:
    'Une licence illimitée existe déjà pour {0} #{1} avec un diamètre d’outil "{8}", créée par {2} le {3}. Voulez-vous continuer et créer une nouvelle licence malgré tout ?',
  ToolDiameter: 'Diamètre de l’outil',
  ToolcodeTooLarge: 'Le code de l’outil est trop grand. Il doit être un nombre entre 1 et 65535',
  'License Reviewer': 'Examinateur de licences',
  'Client Manager': 'Gestionnaire client',
  MeasurementCount: 'Enquêtes',
  ToolSerialNumber: 'Numéro de série de l’outil',
  ExportCsvReport: 'Exporter le rapport CSV',
  ToolType: 'Type d’outil',
  FirstUsedOn: 'Date de première utilisation',
  LastUsedOn: 'Date de dernière utilisation',
  ErrorGeneratingReport: 'Une erreur est survenue lors de la génération du rapport. Veuillez réessayer.',
  ToolUsageReport: 'Rapport d’utilisation des outils',
  ExportToolUsageReport: 'Exporter le rapport d’utilisation des outils',
  ToolUsageReportInProcess: 'Le rapport d’utilisation de l’outil est en cours de génération. Il sera envoyé à votre adresse e-mail une fois terminé.',
  ProjectName: 'Nom du projet',
  Group: 'Groupe',
  SelectOrInviteWarning: 'Veuillez sélectionner ou inviter',
  ManagePartnerOrganization: 'Gérer l’organisation partenaire',
  ManageAdminOrganization: 'Gérer l’organisation administratrice',
};
